module.exports = "/meter3f27740c8bc100e0b0ad4f8a43c81962.svg";